// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"c889cfbd","161":"386163a5","217":"a101ef18","219":"5d8dfa61","230":"85fdc203","692":"5a91ba0a","796":"98611eea","864":"d2bbbfc2","998":"d3761f47"}[chunkId] + ".chunk.js";
};